import React from 'react'
import logo from '../../assets/images/sarafan-logo.png'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  header: {
    background: 'linear-gradient(180deg, #57B0F2 -5.32%, #4255F1 174.36%)',
    textAlign: 'center',
    color: 'white',
    fontSize: '20px',
    height:'113px'
  },
  logo: {
    paddingTop:'30px',
    paddingBottom:'0px',
    width: '60px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '16px'
  }
})

const Header = () => {
  const classes = useStyles()
  return (
    <div className={classes.header}>
      <img src={logo} alt={'sarafan'} className={classes.logo}/>
      <p className={classes.title}>Сарафан</p>
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/App/containers/Header.jsx